import _extends from "@babel/runtime/helpers/extends";
import { Input as InputComponent, SkeletonBrick } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React, { useEffect } from 'react';
import { findFirst } from "../../utils/arrays";
import withEnterKeyHandler from "../../utils/withOnEnterKeyHandler";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Input = withEnterKeyHandler(function (props) {
  var _props$value;
  // NOTE: Carnica postfix doesn't correctly follow large inputs
  var value = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : '';
  var spaces = value.split(/\s/g).length - 1;
  var spaceless = value.replace(/\s/g, '').length;
  var width = findFirst([props.postFix && spaceless * 12 + spaces * 5 + 5, '100%']);
  useEffect(function () {
    if (props.onError && props.error) {
      props.onError();
    }
  }, [props.error]);
  if (props.isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('input--skeleton'),
      "data-t-id": "components-Input"
    }, /*#__PURE__*/React.createElement(SkeletonBrick, {
      height: 16,
      width: 100
    }), /*#__PURE__*/React.createElement(SkeletonBrick, {
      height: 28
    }));
  }
  return /*#__PURE__*/React.createElement(InputComponent, _extends({}, props, {
    className: cn('input__core'),
    maxLength: 16,
    onClear: function onClear() {
      var _props$onClear;
      props.onChange('');
      (_props$onClear = props.onClear) === null || _props$onClear === void 0 || _props$onClear.call(props);
    },
    style: {
      width: width,
      marginRight: -8
    },
    type: props.type,
    wrapperProps: {
      className: cn('input')
    }
  }));
});